import { ENV } from '../config/env';

export const STRIPE_KEY = ENV.stripeKey;
